const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

async function request(endpoint, options = {}) {
  const url = `${BASE_URL}${endpoint}`;

  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  const token = localStorage.getItem('grantsman_token');
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const config = { ...options, headers };

  // Let browser set Content-Type boundary for FormData
  if (options.body instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  let response;
  try {
    response = await fetch(url, config);
  } catch {
    throw { message: 'Cannot reach the server. Please check your connection and try again.', code: 'NETWORK_ERROR', status: 0 };
  }

  let data;
  try {
    data = await response.json();
  } catch {
    throw { message: 'Unexpected server response. Please try again.', code: 'PARSE_ERROR', status: response.status };
  }

  if (!response.ok || !data.success) {
    throw {
      message: data?.error?.message || 'An unexpected error occurred.',
      code:    data?.error?.code    || 'SERVER_ERROR',
      status:  response.status,
      raw:     data,
    };
  }

  return data;
}

export const apiClient = {
  get:      (endpoint, options = {}) => request(endpoint, { method: 'GET', ...options }),
  post:     (endpoint, body, options = {}) => request(endpoint, { method: 'POST', body: JSON.stringify(body), ...options }),
  patch:    (endpoint, body, options = {}) => request(endpoint, { method: 'PATCH', body: JSON.stringify(body), ...options }),
  delete:   (endpoint, options = {}) => request(endpoint, { method: 'DELETE', ...options }),
  postForm: (endpoint, formData, options = {}) => request(endpoint, { method: 'POST', body: formData, ...options }),
};

export default apiClient;